import { Box, Slider } from '@mui/material';
import React from 'react';
import { MoneyInputv3 } from './moneyFormatInput';

const moneyInputStyle = {
  minWidth: '80px',
  fontSize: '12px',
  textAlign: 'right',
  padding: 0, // Set padding to 0
  '& .MuiOutlinedInput-root': {
    border: 'none', // Remove border
    '& fieldset': {
      border: 'none', // Remove the outline/border
    },
    padding: 0, // Remove padding inside the input
  },
  '.MuiInputBase-input': {
    padding: 0, // Remove padding for the input text
  },
  '.MuiInputBase-root': {
    fontSize: '12px',
  },
  label: {
    fontSize: '12px',
  },
  '.MuiFormLabel-root': {
    color: 'input.font',
  },
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: 'input.border',
  },
  '.MuiOutlinedInput-input': {
    textAlign: 'right',
    padding: 0, // Remove padding for input text
  },
};

/**
 * @deprecated This component is deprecated. Please use MoneyTextFieldRange instead.
 */
const MoneyRanger = ({ onChange = () => {}, min = 0, max = 1000000, maxValue = 100000, minValue = 0, hideSlider = true, currencyType }) => {
  console.warn('⚠️ MoneyRanger is deprecated. Use MoneyTextFieldRange instead.');
  console.log({ min, max, maxValue, minValue });
  // min = min === "" ? (minValue === maxValue ? 0 : minValue) : min;
  // max = max === "" ? maxValue : max;
  console.log(maxValue);
  const handleChange = (event, newValue, activeThumb) => {
    // Prevent swapping of the values
    if (min > max) {
      if (activeThumb === 0) {
        onChange([max, max]);
      } else {
        onChange([min, min]);
      }
    } else {
      onChange(newValue);
    }
  };

  const handleInputChange = (index) => (value) => {
    const val = value === '' ? 0 : parseFloat(value);

    let newValues = [min, max];

    if (index === 0) {
      newValues[0] = val;
    } else {
      newValues[1] = val;
    }

    onChange(newValues);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '90%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {!hideSlider && (
        <Slider
          value={[min ?? 0, max]}
          onChange={handleChange}
          valueLabelDisplay="auto"
          disableSwap
          defaultValue={1000}
          min={minValue}
          max={maxValue}
          sx={{
            padding: '0px',
            paddingTop: '10px',
            width: '90%',
            height: '6px',
            '& .MuiSlider-thumb': {
              height: '12px',
              width: '12px',
              '& .MuiSlider-valueLabel': {
                fontSize: '10px',
                top: '-10px',
              },
              '&:before': {
                boxShadow: 'none',
              },
            },
            '& .MuiSlider-rail': {
              height: '4px',
            },
            '& .MuiSlider-track': {
              height: '4px',
            },
            '.MuiSlider-thumb.Mui-focusVisible, .MuiSlider-thumb:hover': {
              'box-shadow': 'none !important',
            },
          }}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <MoneyInputv3
          state={min}
          currencyType={currencyType}
          onChange={handleInputChange(0)}
          sx={{
            ...moneyInputStyle,
            minWidth: `${Math.max(8, String(min).length + 7)}ch`,
          }}
          inputProps={{
            'aria-label': 'min value',
            style: { padding: '0 5px' },
          }}
        />
        <span style={{ margin: '0 8px' }}>to</span>
        <MoneyInputv3
          state={max}
          currencyType={currencyType}
          onChange={handleInputChange(1)}
          sx={{
            ...moneyInputStyle,
            minWidth: `${Math.max(8, String(max).length + 7)}ch`,
          }}
          inputProps={{
            'aria-label': 'max value',
            style: { padding: '0 5px', textAlign: 'right' },
          }}
        />
      </Box>
    </Box>
  );
};

export default MoneyRanger;
